export const SET_PAGE_NUMBER = "SET_PAGE_NUMBER";
export const SET_PAGE_NAME = "SET_PAGE_NAME";
export const SET_PAGE_QUERY = "SET_PAGE_QUERY";
